import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "./ui/alert-dialog";
import { AlertTriangle } from "lucide-react";

/**
 * Confirmation dialog shown when emitting an invoice that contains client
 * names already used in previous invoices of the same type.
 */
export default function DuplicateNamesDialog({ open, onOpenChange, duplicates, invoiceType, onConfirm }) {
  const typeLabel = invoiceType === "advance" ? "adelanto" : "final";

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent data-testid="duplicates-dialog" className="max-w-lg">
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2">
            <AlertTriangle className="text-amber-500" size={20} />
            Clientes repetidos detectados
          </AlertDialogTitle>
          <AlertDialogDescription>
            Los siguientes clientes ya aparecen en una factura de <strong>{typeLabel}</strong> emitida anteriormente.
            Revisa antes de emitir para evitar facturar dos veces el mismo concepto.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <div className="max-h-72 overflow-y-auto -mx-2 px-2">
          <table className="w-full text-sm">
            <thead className="bg-slate-50 sticky top-0">
              <tr>
                <th className="text-left py-2 px-3 text-[10px] uppercase tracking-wider text-slate-600 font-semibold">Cliente</th>
                <th className="text-left py-2 px-3 text-[10px] uppercase tracking-wider text-slate-600 font-semibold">Ya estaba en</th>
              </tr>
            </thead>
            <tbody>
              {duplicates.map((d, i) => (
                <tr key={`${d.name}-${d.invoiceNumber}-${i}`} className="border-t border-slate-100" data-testid={`duplicate-row-${i}`}>
                  <td className="py-2 px-3 text-slate-900">{d.name}</td>
                  <td className="py-2 px-3 text-slate-600 font-mono">{d.invoiceNumber}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="duplicates-cancel-btn">Cancelar emisión</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm} className="bg-slate-900 hover:bg-slate-800" data-testid="duplicates-confirm-btn">
            Emitir igualmente
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
